import telegramAnalytics from "@telegram-apps/analytics"
import { useEffect, useState } from "react"
import { getTgUserId } from "@/helpers/tgWebApp"
import { initTelegramData } from "./utils/initTelegramData.ts"

export const useAppInit = () => {
  const [isInit, setIsInit] = useState<boolean>(false)

  useEffect(() => {
    if (import.meta.env.VITE_NODE_ENV !== "local") {
      if (!getTgUserId()) {
        setIsInit(true)
        return
      }
    }

    initTelegramData()
    setIsInit(true)

    setTimeout(async () => {
      await telegramAnalytics.init({
        token: import.meta.env.VITE_DC_TOKEN,
        appName: import.meta.env.VITE_DC_ANALYTICS_IDENTIFIER
      })
    })
  }, [])

  return { isInit }
}
